'use strict';
'use es6';
// This is an auto-generated file. Please do not edit directly.
// For instructions on editing source files, please see:
// https://git.hubteam.com/HubSpot/UIComponents/blob/master/UIComponents/docs/open-source.md
// *****************************************************************************************

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _chunk = require('./chunk1');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SyntheticEvent = function SyntheticEvent(value, source) {
  return {
    source: source,
    target: { value: value },
    currentTarget: { value: value },

    preventDefault: function preventDefault() {
      if (source) {
        source.preventDefault();
      }
    },
    stopPropagation: function stopPropagation() {
      if (source) {
        source.stopPropagation();
      }
    },


    // ******************************************************************************************************
    // Methods below exist solely for backwards-compat with previous SyntheticEvent based on Immutable Record
    // ******************************************************************************************************

    /**
     * @param {String} key
     * @returns {String} value stored at this[key] (e.g. one of the above: source, target, ...)
     */
    get: function get(key) {
      return this[key];
    },


    /**
     * @param  {[String]} path=[]
     * @returns {String} value stored at this[path[0]][path[1]][...]
     */
    getIn: function getIn() {
      var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var val = this;
      try {
        path.forEach(function (key) {
          val = val[key];
        });
      } catch (error) {
        throw new Error('SyntheticEvent - path not found: ' + path.join('.') + '. Original error: "' + error.message + '"');
      }

      return val;
    }
  };
};

function callIfPossible(prop) {
  if (typeof prop !== 'function') {
    return prop;
  }

  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return prop.apply(undefined, args);
}

var defaultOnSubmit = function defaultOnSubmit(evt) {
  evt.preventDefault();
};

/**
 * Encapsulate markup and allow for future extension (validation, etc.)
 **/

var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form() {
    var _ref;

    var _this, _ret;

    _classCallCheck(this, Form);

    var _temp;

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.handleKeyDown = function (evt) {
      var _this$props = _this.props,
          submitOnCtrlEnter = _this$props.submitOnCtrlEnter,
          onKeyDown = _this$props.onKeyDown,
          onSubmit = _this$props.onSubmit;
      var key = evt.key;

      var inputFocused = document.activeElement instanceof HTMLInputElement;
      if (submitOnCtrlEnter && key === 'Enter') {
        if (evt.metaKey || evt.ctrlKey && !inputFocused) {
          callIfPossible(onSubmit, SyntheticEvent());
        }
      }
      callIfPossible(onKeyDown, evt);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Form, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          action = _props.action,
          __submitOnCtrlEnter = _props.submitOnCtrlEnter,
          children = _props.children,
          __onKeyDown = _props.onKeyDown,
          onSubmit = _props.onSubmit,
          rest = (0, _chunk.objectWithoutProperties)(_props, ['action', 'submitOnCtrlEnter', 'children', 'onKeyDown', 'onSubmit']);

      return _react2.default.createElement('form', (0, _chunk.extends)({}, rest, {
        action: action,
        onKeyDown: this.handleKeyDown,
        onSubmit: !action && !onSubmit ? defaultOnSubmit : onSubmit
      }), children);
    }
  }]);

  return Form;
}(_react.Component);

Form.propTypes = {
  action: _react.PropTypes.string,
  children: _react.PropTypes.node.isRequired,
  className: _react.PropTypes.string,
  onKeyDown: _react.PropTypes.func,
  onSubmit: _react.PropTypes.func,
  submitOnCtrlEnter: _react.PropTypes.bool.isRequired
};
Form.defaultProps = {
  submitOnCtrlEnter: true
};

exports.default = Form;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/vendor/canvas/Form.js
// module id = 335
// module chunks = 0